import React from "react";
import "../index.scss";
import HorizontalCalendar from "../../../shared/horizontal-calendar";
import moment from "moment/moment";
import AvailableSeat from "../components/availableSeat";
import { AVAILABLE_SLOT } from "../../../../constants/app";
import useBlockTime from "../../../../hooks/use-block-times";
import useCustomDiscountOptions from "../../../../hooks/use-custom-discount";
import { cloneDeep } from "lodash";
import styled from "styled-components";
import GourmetSelectMenu from "../components/gourmetSelectMenu";
// import { RequiredLabel } from "./common-styled";
import utils from "../../../../core/utils";
import LoginModal from "../components/loginModal";
import ConfirmBookingModal from "../components/confirmBookingModal";

const DiscountWrapper = styled.div`
  font-size: 12px;
  max-width: 100px;
  text-align: center;
`;

const GourmetContainer = React.memo((props) => {
  const { shopDetail, userBookingData, shopMenus, shopDiscounts, userToken } =
    props.user;
  const {
    seats,
    table,
    chosenTime,
    total,
    discount,
    chosenMenu,
    selectedDate,
    otherDiscount,
    timeDiscount,
    special_menu,
    percentDiscount,
  } = userBookingData;

  const { __blockTimes, handleSetBlockTime } = useBlockTime(
    shopDetail,
    moment(formatSelectedDateObject()).toDate()
  );
  const [availableSeats, setAvailableSeats] = React.useState([]);
  const [availableTables, setAvailableTables] = React.useState([]);
  const [isShowLoginModal, setIsShowLoginModal] = React.useState(false);
  const [isShowConfirmBookingModal, setIsShowConfirmBookingModal] =
    React.useState();
  const [blockTimes, setBlockTimes] = React.useState([]);
  const { listDiscount } = useCustomDiscountOptions({
    currentDate: formatSelectedDateObject(),
  });

  React.useEffect(() => {
    if (total && percentDiscount) {
      handleSaveDataToState({
        timeDiscount: (+percentDiscount * +total) / 100,
      });
    }
  }, []);

  React.useEffect(() => {
    handleFetchAvailableSeat();
  }, []);

  React.useEffect(() => {
    if (selectedDate?.date && !table) {
      handleSetBlockTime();
    }
  }, [selectedDate]);

  React.useEffect(() => {
    if (seats) {
      handleFetchAvailableTable();
    }
  }, [seats, selectedDate]);

  React.useEffect(() => {
    if (table && availableTables?.length) {
      const times = availableTables.find(
        (item) => item.id === table
      )?.available_slots;

      const timeAvailable = times?.filter(
        (item) => item.status === AVAILABLE_SLOT
      );

      setBlockTimes(timeAvailable);
    }
  }, [table, availableTables]);

  const canPay = React.useMemo(() => {
    return (
      (chosenMenu || special_menu) && chosenTime && selectedDate?.date && table
    );
  }, [chosenMenu, chosenTime, selectedDate, special_menu, table]);

  const handleChangeDate = (date) => {
    handleSaveDataToState({
      selectedDate: date,
      chosenMenu: "",
      total: "",
      discount: "",
      duration: "",
      chosenTime: "",
      isUserChosenTime: false,
      adultCount: 0,
      childAges: [],
      childCount: 0,
      note: "",
      phone: "",
      table: null,
      seats: "",
      other_discount: "",
      timeDiscount: 0,
      percentDiscount: 0,
    });
  };

  const handleFetchAvailableSeat = async () => {
    const result = await window.axios({
      url: `shop/${shopDetail.id}/seat/`,
      method: "get",
    });
    if (result.data.results) {
      const data = result.data.results.map((item) => item.seat_no);
      setAvailableSeats(data);
    }
  };

  const handleFetchAvailableTable = async () => {
    const result = await window.axios({
      url: `shop/${shopDetail.id}/table/`,
      method: "get",
      params: {
        date: formatSelectedDateObject(),
        seats: seats,
        discount: true,
      },
    });
    setAvailableTables(result.data.results);
  };

  const handleTableSelected = (table) => {
    handleSaveDataToState({
      table,
      chosenTime: "",
    });
  };

  const handleSaveDataToState = (value) => {
    props.dispatchActions.setUserBookingData({
      key: shopDetail.id,
      value: {
        ...userBookingData,
        ...value,
      },
    });
  };

  const handleBlockTimeChange = (chosenTime, blockTimeDiscount) => {
    let newDiscount = 0;
    if (blockTimeDiscount) {
      if (blockTimeDiscount.type === "Percentage" && !+total) {
        handleSaveDataToState({
          chosenTime,
          percentDiscount: +blockTimeDiscount.value,
        });
      } else {
        if (blockTimeDiscount.type === "Fixed") {
          newDiscount = +blockTimeDiscount.value;
        } else if (blockTimeDiscount.type === "Percentage") {
          newDiscount = (+blockTimeDiscount.value * +total) / 100;
        } else {
          newDiscount = blockTimeDiscount.value_other;
        }
        handleSaveDataToState({
          chosenTime,
          timeDiscount: newDiscount,
        });
      }
    }
  };

  const renderDiscountValue = (discount) => {
    if (discount.type === "Other") return discount.value_other;
    return `${discount.value?.split(".")?.[0]} ${
      discount.type === "Fixed" ? "円" : "%"
    }`;
  };

  const renderDiscount = React.useCallback(
    (discount) => {
      if (!discount) return null;
      return (
        <DiscountWrapper className="d-flex align-items-center">
          <div className="me-1 text-truncate lh-lg">
            {renderDiscountValue(discount)}
          </div>
        </DiscountWrapper>
      );
    },
    [listDiscount]
  );

  const getDefaultDiscount = React.useCallback(
    (discount, time) => {
      if (!discount) return null;
      const data = discount.filter((item) => {
        const { start_block, end_block } = item;
        const format_valid_to = Number(end_block.replace(":", ""));
        const format_valid_from = Number(start_block.replace(":", ""));
        const format_time = Number(time.replace(":", ""));

        return (
          Number(format_valid_from) <= format_time &&
          Number(format_valid_to) > format_time
        );
      });

      return data.length ? data[0] : null;
    },
    [listDiscount]
  );

  const initDiscountData = React.useCallback(
    (ids) => {
      return listDiscount.filter((item) => ids.includes(item.id))?.[0];
    },
    [listDiscount]
  );

  function formatSelectedDateObject() {
    const { year, month, date } = selectedDate;
    if (!year || !month || !date) return null;
    return `${year}-${String(month).padStart(2, "0")}-${String(date).padStart(
      2,
      "0"
    )}`;
  }

  const renderAvailableTable = () => {
    if (!shopDetail.show_tables) return null;
    if (!availableTables?.length) {
      return seats ? (
        <div className="py-2">ご希望の人数に対応できる席がありません。</div>
      ) : null;
    }
    return (
      <div className="d-flex gap-2 pb-2 flex-wrap">
        {availableTables.map(({ id, name }) => {
          const isActive = table === id;
          return (
            <button
              key={id}
              onClick={() => handleTableSelected(id)}
              className={`btn px-3 py-2 border ${
                isActive ? "text-white border-0" : "btn-outline-secondary"
              }`}
              style={{
                backgroundColor: isActive ? shopDetail.color : undefined,
                minWidth: "60px",
              }}
            >
              {name}
            </button>
          );
        })}
      </div>
    );
  };

  const renderBlockTimeList = React.useCallback(() => {
    const data = blockTimes?.length ? blockTimes : __blockTimes;
    if (!data) return null;
    const { year, date, month } = selectedDate;
    return (
      <div className="mt-4">
        <div className="d-flex align-items-center mb-3">
          <span className="text-dark fw-bold me-2">時間</span>
        </div>
        <div className="d-flex gap-2 pb-2 flex-wrap">
          {data.map((time) => {
            const value = time.start_time || time;
            const isPrevDate = moment(
              `${year}-${month}-${date} ${value}`,
              "YYYY-MM-DD HH:mm"
            ).isBefore(moment());
            const isActive = chosenTime === value;
            const discount = !table
              ? getDefaultDiscount(cloneDeep(listDiscount), value)
              : time.discount_ids?.length
              ? initDiscountData(time.discount_ids)
              : null;
            return (
              <button
                key={value}
                disabled={isPrevDate}
                onClick={() => handleBlockTimeChange(value, discount)}
                className={`btn btn-sm px-3 py-2 border ${
                  isActive ? "text-white border-0" : "btn-outline-secondary"
                }`}
                style={{
                  backgroundColor: isActive ? shopDetail.color : undefined,
                  minWidth: "60px",
                }}
                title=""
              >
                {value}
                {renderDiscount(discount)}
              </button>
            );
          })}
        </div>
      </div>
    );
  }, [
    listDiscount,
    table,
    blockTimes,
    chosenTime,
    __blockTimes,
    userBookingData,
  ]);

  const getTotalDuration = (menus) => {
    if (!menus?.length) return 0;
    return menus
      .map((chosen) => shopMenus?.find((menu) => +chosen === menu.id))
      ?.reduce((acc, curr) => {
        return (acc += Number(curr?.duration));
      }, 0);
  };

  const getTotalDiscount = (menus) => {
    if (!menus.length) return 0;
    let totalDiscount = menus
      .map((chosen) => shopMenus?.find((menu) => +chosen === menu.id))
      ?.reduce((acc, curr) => {
        const discount = shopDiscounts.find(
          (item) => curr?.discount === item.id
        );

        let amount = acc;

        if (discount) {
          if (discount.type === "Percentage") {
            amount += (+discount.value * +curr?.price) / 100;
          } else {
            amount += +discount.value;
          }
        }
        return amount;
      }, 0);
    return totalDiscount;
  };

  const getTotalMoney = (menus) => {
    if (!menus.length) return 0;
    return menus
      .map((chosen) => shopMenus?.find((menu) => +chosen === menu.id))
      ?.reduce((acc, curr) => {
        return (acc += Number(curr.price));
      }, 0);
  };

  const onConfirmButtonClick = () => {
    if (!userToken) {
      setIsShowLoginModal(true);
      return;
    }
    setIsShowConfirmBookingModal(true);
  };

  const onCloseLoginModal = (data) => {
    setIsShowLoginModal(false);
    if (data && data.loginSuccess === true) {
      setIsShowConfirmBookingModal(true);
    }
  };

  const onCloseConfirmBookingModal = async (bookingId) => {
    setIsShowConfirmBookingModal(false);
    if (!bookingId) {
      return;
    }
    handleSaveDataToState({
      chosenMenu: "",
      total: "",
      discount: "",
      duration: "",
      chosenTime: "",
      isUserChosenTime: false,
      adultCount: 0,
      childAges: [],
      childCount: 0,
      note: "",
      phone: null,
      table: null,
      seats: "",
    });

    props.history.push(
      `/${shopDetail.id}/booking/${bookingId}/booking-success`
    );
  };

  const renderTotalMoney = () => {
    return (
      <div className="py-2">
        <div className="d-flex align-items-center justify-content-between">
          <div className="options__label fw-bold">金額:</div>
          <div className="text-danger">
            ¥ {utils.formatMoney(total || 0, 0, 3, ",", ".")}
          </div>
        </div>
      </div>
    );
  };

  const renderTotalDuration = () => {
    const duration = getTotalDuration(chosenMenu?.split(","));
    return (
      <div className="py-2">
        <div className="d-flex align-items-center justify-content-between">
          <div className="options__label fw-bold">時間: </div>
          <div>{duration || 0} 分</div>
        </div>
      </div>
    );
  };

  const renderTotalDiscount = () => {
    let totalDiscount = discount;
    let discountString = null;
    if (timeDiscount && typeof timeDiscount === "string") {
      discountString = <div>{timeDiscount}</div>;
    } else {
      totalDiscount = Number(discount || 0) + Number(timeDiscount || 0);
    }
    return (
      <div className="py-2">
        <div className="d-flex align-items-center justify-content-between">
          <div className="options__label fw-bold">割引:</div>
          <div className="text-end text-danger">
            {discountString}
            {otherDiscount && <div>{otherDiscount.value_other}</div>}
            <div className="mt-1">
              ¥ {utils.formatMoney(totalDiscount || 0, 0, 3, ",", ".")}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderLastPrice = () => {
    let totalDiscount = discount;
    if (timeDiscount && typeof timeDiscount === "number") {
      totalDiscount = Number(discount || 0) + Number(timeDiscount || 0);
    }
    return (
      <div className="py-2">
        <div className="d-flex align-items-center justify-content-between">
          <div className="options__label fw-bold">見積金額:</div>
          <div className="text-danger">
            ¥{" "}
            {total
              ? utils.formatMoney(total - totalDiscount, 0, 3, ",", ".")
              : 0}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div id="user-booking-home" className="user-home fade-out">
      <div className="user-home__wrapper bg-white">
        <p className="text-center font-bold pt-4 fw-bold fs-4">
          <i className="fas fa-solid fa-calendar me-1 fs-4"></i>予約
        </p>
        <div className="pb-4">
          <HorizontalCalendar
            shopId={shopDetail.id}
            onChange={handleChangeDate}
            selectedDate={selectedDate}
            pageColor={shopDetail.color}
            workingHoursOfWeek={shopDetail.workingHoursOfWeek}
          />
          <div className="available-seats pb-4">
            <AvailableSeat
              availableSeats={availableSeats}
              {...props}
              pageColor={shopDetail.color} // Orange color for gourmet booking
            />
          </div>
          <div className="px-3">
            {renderAvailableTable()}
            {renderBlockTimeList()}
          </div>
          <div className="mt-4 px-3">
            <GourmetSelectMenu
              {...props}
              pageColor={shopDetail.color}
              getTotalDiscount={getTotalDiscount}
              getTotalDuration={getTotalDuration}
              getTotalMoney={getTotalMoney}
            />
          </div>
          <div className="pt-4 px-3">
            <div className="border-bottom pb-2">
              <div>{renderTotalDuration()}</div>
              <div>{renderTotalMoney()}</div>
              <div>{renderTotalDiscount()}</div>
            </div>
          </div>

          <div className="__total pb-4 pt-2 px-3">
            <div>{renderLastPrice()}</div>
          </div>
          <div className="row justify-content-center">
            <div className="mt-4 col-md-6 col-xs-12 px-3 ">
              <button
                className="user-home__confirm-btn"
                style={{
                  backgroundColor: shopDetail.color,
                }}
                disabled={!canPay}
                onClick={onConfirmButtonClick}
              >
                確定
              </button>
            </div>
          </div>
        </div>
      </div>
      {isShowLoginModal && (
        <LoginModal onClose={onCloseLoginModal} {...props} />
      )}
      {isShowConfirmBookingModal && (
        <ConfirmBookingModal onClose={onCloseConfirmBookingModal} {...props} />
      )}
    </div>
  );
});

export default GourmetContainer;
